/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';

import { useAction } from '../../../Common/hooks';
import { oneSecond } from '../../../Common/constants';
import { setBusinessFilters } from '../../actions';
import { getBusinessFilters } from '../../selectors';
import { businessFiltersInitialState } from '../../reducers';
import { getBusinessFilterOptions } from '../../services';

const useBusinessFilterBar = () => {
  const storeFilters = useSelector(getBusinessFilters);
  const setStoreFilters = useAction(setBusinessFilters);
  const debouncedFilterChange = useCallback(debounce(setStoreFilters, oneSecond), []);
  const [showResetButton, setShowResetButton] = useState(false);
  const [partnersOptions, setPartnersOptions] = useState([]);
  const [aggregatorsOptions, setAggregatorsOptions] = useState([]);
  const [filters, setFilters] = useState({ ...storeFilters });

  useEffect(() => {
    const callFilterOptions = async () => {
      const filterOptions = await getBusinessFilterOptions();
      const [partnersFilterOptions, aggregatorsFilterOptions] = filterOptions;

      setPartnersOptions(partnersFilterOptions);
      setAggregatorsOptions(aggregatorsFilterOptions);
    };

    callFilterOptions();
  }, []);

  useEffect(() => {
    debouncedFilterChange(filters);
    setShowResetButton(!isEqual(filters, businessFiltersInitialState));
  }, [filters]);

  const handleFilterChanges =
    filterName =>
    ({ target: { value } }) => {
      const filter = { [filterName]: value };

      setFilters({
        ...filters,
        ...filter,
      });
    };

  const handleResetFilter = () => {
    setFilters({ ...businessFiltersInitialState });
    setShowResetButton(false);
  };

  const handleEnterPress = event => {
    if (event.key === 'Enter') {
      debouncedFilterChange.flush();
    }
  };

  return {
    showResetButton,
    handleFilterChanges,
    handleResetFilter,
    handleEnterPress,
    partnersOptions,
    aggregatorsOptions,
    filters,
  };
};

export default useBusinessFilterBar;
